import { Stack } from "@chakra-ui/react";

import { GridItemType } from "components/Chakra/Card/CardMotion";
import { IPhoto } from "utils/offer";
import Card from "../Card";
import PhotoCard from "../PhotoCard";

const itemsGallery: Array<IPhoto> = [
  {
    path: "/img/scenes/Matterport/tab-3-1.webp",
    id: 271271,
  },
];

export const thirdTabItems: Array<GridItemType> = [
  {
    content: (
      <Card
        title="Půdorys doplní kompletní představu nemovitosti"
        subTitle="Detailní půdorys nemovitosti umožní kupujícím si lépe představit dispozici, velikost místnosti a rozložení jednotky. Zájemci tak přesně ví, jak by jejich vysněné bydlení mohlo vypadat."
      />
    ),
    isGalerryIcon: false,
    gridItemSetting: { name: "A", h: { base: "360px", md: "555px" } },
    filterBrightnessPercent: 60,
  },
  {
    content: (
      <Stack flex={1}>
        <PhotoCard id={itemsGallery[0].id} itemsGallery={itemsGallery} />
      </Stack>
    ),
    gridItemSetting: { name: "B", h: { base: "360px", md: "555px" } },
    filterBrightnessPercent: 60,
  },
];
